/**
 * ARIA Identifier Badge Component
 * Version: 1.0.1
 *
 * ARIA-7: Show None/TE/PA badge across job lists
 * - TE: Technical Estimate
 * - PA: PA Order — a SyteLine Parts Authorization order (co_mst), the original
 *   warranty-driving purchase order. Standalone Job record, not linked to any
 *   SE order.
 */

import type { IdentifierType } from '../../types';

interface IdentifierBadgeProps {
  type: IdentifierType;
  showNone?: boolean;
}

export function IdentifierBadge({ type, showNone = false }: IdentifierBadgeProps) {
  if (type === 'none' && !showNone) {
    return null;
  }

  if (type === 'TE') {
    return (
      <span
        className="badge-te"
        title="Technical Estimate - Requires technical assessment"
      >
        TE
      </span>
    );
  }

  if (type === 'PA') {
    return (
      <span
        className="badge-pa"
        title="PA Order - Parts Authorization order, the original warranty-driving purchase order"
      >
        PA
      </span>
    );
  }

  if (showNone) {
    return <span className="badge badge-gray">-</span>;
  }

  return null;
}
